<div class="dialog-container">
  <div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-header">
    <h4>{{ "users.dialogs.selection.header" | translate }}</h4>
    <button class="icon-close" (click)="dialogRef.close()"></button>
  </div>
  <div class="container">
    <div class="search-bar">
      <div class="first-row">
        <div class="input-container">
          <sag-ui-input class="primary-input flex-1" [label]="'users.item.firstName' | translate" [(ngModel)]="firstName" (keyup)="applyFilter($event)" />
          <sag-ui-input class="primary-input flex-1" [label]="'users.item.surName' | translate" [(ngModel)]="surName" (keyup)="applyFilter($event)" />
          <sag-ui-input class="primary-input flex-1" [label]="'users.item.eMail' | translate" [(ngModel)]="eMail" (keyup)="applyFilter($event)" />
        </div>
        <div class="button-container">
          <sag-ui-button class="primary" [icon]="'search'" (click)="applyFilter($event)">
            {{ "generic.buttons.search" | translate }}
          </sag-ui-button>
          <sag-ui-button class="cancel" (click)="clearFilter()">
            {{ "generic.buttons.clear" | translate }}
          </sag-ui-button>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="table-container">
        <div class="relative">
          <table sag-ui-table>
            <thead sag-ui-thead>
              <tr>
                @for (column of displayedColumns; track column) {
                  <th scope="col" sag-ui-th>{{ column }}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (user of dataSource; track user) {
                <tr sag-ui-tr>
                  <td sag-ui-td>
                    <sag-ui-radio name="selected" value="item" (change)="changeSelected(user)" />
                  </td>
                  <td sag-ui-td>{{ user.firstName }}</td>
                  <td sag-ui-td>{{ user.surName }}</td>
                  <td sag-ui-td>{{ user.mail }}</td>
                  <td sag-ui-td>{{ user.department }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="actions-container">
      <sag-ui-button class="cancel" (click)="dialogRef.close()">
        {{ "generic.buttons.cancel" | translate }}
      </sag-ui-button>

      <sag-ui-button class="primary" [disabled]="!selectedUser" (click)="closeDialog()">
        {{ "generic.buttons.confirm" | translate }}
      </sag-ui-button>
    </div>
  </div>
</div>
